var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('customer-list',{attrs:{"click-item":_vm.clickItem,"is-mobile":true,"customers":_vm.customers,"search-mode":_vm.searchMode,"allowed-stores":_vm.User.AllowedStores,"selected-platform":_vm.storePlatform,"report-mode":_vm.reportMode},on:{"submitsearch":function($event){return _vm.handleSubmitSearch($event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a590cd9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Plugin/CustomerList/CustomerList.vue
// module id = qArU
// module chunks = 1